'use strict';

var GridContributingServicesFilterFactory = function GridContributingServicesFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ServicesFilterByClassFactory', 'ServicesFilterByDateRangeFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function GridContributingServicesFilter() {
    DemandFilter.call(this, 'contributing-services-mode', 'contributing-services');
    this.registerFilters(injectedFilters);
  }
  GridContributingServicesFilter.prototype = Object.create(DemandFilter.prototype);
  GridContributingServicesFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return GridContributingServicesFilter;
};
GridContributingServicesFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = GridContributingServicesFilterFactory;